import { toast, ToastOptions, Renderable, ValueOrFunction } from "react-hot-toast";

const defaultOptions: ToastOptions = {
  duration: 3500,
  position: "top-right",
};

export const showSuccess = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.success(message, { ...defaultOptions, className: "toast-success", ...options });
};

export const showError = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.error(message, { ...defaultOptions, className: "toast-error", ...options });
};

export const showInfo = (message: Renderable, options: ToastOptions = {}): string => {
  return toast(message, {
    ...defaultOptions,
    icon: "ℹ️",
    className: "toast-info",
    ...options,
  });
};

export const showWarning = (message: Renderable, options: ToastOptions = {}): string => {
  return toast(message, {
    ...defaultOptions,
    icon: "⚠️",
    className: "toast-warning",
    ...options,
  });
};

export const showLoading = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.loading(message, { ...defaultOptions, className: "toast-loading", ...options });
};

export const showPromise = <T,>(
  promise: Promise<T>,
  msgs: {
    loading: Renderable;
    success: ValueOrFunction<Renderable, T>;
    error: ValueOrFunction<Renderable, any>;
  },
  options: ToastOptions = {}
): Promise<T> => {
  return toast.promise(promise, msgs, { ...defaultOptions, ...options });
};

export const dismissToast = (toastId?: string): void => {
  toast.dismiss(toastId);
};

export const removeToast = (toastId?: string): void => {
  toast.remove(toastId);
};

const toastService = {
  success: showSuccess,
  error: showError,
  info: showInfo,
  warning: showWarning,
  loading: showLoading,
  promise: showPromise,
  dismiss: dismissToast,
  remove: removeToast,
  toast,
};

export default toastService;
